import React, { useState, useEffect } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

const Footer = () => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/config/footer`)
      .then(r => r.json())
      .then(setConfig)
      .catch(() => setConfig(null));
  }, []);

  const isVisible = (section, item) => {
    if (!config) return true; // Default: show everything
    const sec = config[section];
    if (!sec || !sec.visible) return false;
    if (item && sec.items) return sec.items[item] !== false;
    return true;
  };

  return (
    <footer className="luxury-footer">
      <div className="footer-content">
        <div className="footer-main">
          <div className="brand-section">
            <div className="luxury-logo">
              <h2 className="brand-name">Uncharted Travels</h2>
            </div>
            <p className="brand-tagline platform-tagline">where exclusive experiences meet accessibility</p>
            <div className="luxury-badges">
              <span className="badge">Travel Protection</span>
              <span className="badge">Quality Service</span>
              <span className="badge">Secure Payments</span>
              <span className="badge">AI-Powered</span>
            </div>
          </div>

          {isVisible('quick_links') && (
            <div className="footer-section">
              <h4>Quick Links</h4>
              <ul>
                {isVisible('quick_links', 'destinations') && <li><a href="#destinations">Destinations</a></li>}
                {isVisible('quick_links', 'special_deals') && <li><a href="#deals">Special Deals</a></li>}
                {isVisible('quick_links', 'travel_inspiration') && <li><a href="#inspiration">Travel Inspiration</a></li>}
                {isVisible('quick_links', 'travel_guides') && <li><a href="#guides">Travel Guides</a></li>}
              </ul>
            </div>
          )}

          {isVisible('services') && (
            <div className="footer-section">
              <h4>Services</h4>
              <ul>
                {isVisible('services', 'flight_booking') && <li><a href="#flights">Flight Booking</a></li>}
                {isVisible('services', 'hotel_reservations') && <li><a href="#hotels">Hotel Reservations</a></li>}
                {isVisible('services', 'activities_tours') && <li><a href="#activities">Activities & Tours</a></li>}
                {isVisible('services', 'travel_packages') && <li><a href="#packages">Travel Packages</a></li>}
              </ul>
            </div>
          )}

          {isVisible('support') && (
            <div className="footer-section">
              <h4>Support</h4>
              <ul>
                {isVisible('support', 'help_center') && <li><a href="#help">Help Center</a></li>}
                {isVisible('support', 'contact_us') && <li><a href="#contact">Contact Us</a></li>}
                {isVisible('support', 'booking_help') && <li><a href="#booking-help">Booking Help</a></li>}
                {isVisible('support', 'travel_tips') && <li><a href="#travel-tips">Travel Tips</a></li>}
              </ul>
            </div>
          )}

          {isVisible('company') && (
            <div className="footer-section">
              <h4>Company</h4>
              <ul>
                {isVisible('company', 'about_us') && <li><a href="#about">About Us</a></li>}
                {isVisible('company', 'careers') && <li><a href="#careers">Careers</a></li>}
                {isVisible('company', 'press') && <li><a href="#press">Press</a></li>}
                {isVisible('company', 'partners') && <li><a href="#partners">Partners</a></li>}
              </ul>
            </div>
          )}
        </div>

        <div className="footer-premium-contact">
          <div className="contact-methods">
            <h4>Get in Touch</h4>
            <div className="contact-item">
              <span className="contact-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
              </span>
              <div>
                <strong>Live Chat</strong>
                <p>Available 24/7 for instant assistance</p>
              </div>
            </div>
            <div className="contact-item">
              <span className="contact-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              </span>
              <div>
                <strong>Email Support</strong>
                <p>support@unchartedtravel.agency</p>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-legal">
            <p>&copy; {new Date().getFullYear()} Uncharted Travels. All rights reserved.</p>
            <div className="legal-links">
              <a href="#privacy">Privacy Policy</a>
              <a href="#terms">Terms of Service</a>
              <a href="#cookies">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
